function createFieldSetter(setState, field) {
  return (valueOrUpdater) => {
    setState((currentState) => {
      const currentValue = currentState[field];

      const nextValue =
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(currentValue)
          : valueOrUpdater;

      return {
        ...currentState,
        [field]: nextValue,
      };
    });
  };
}

export default createFieldSetter;